















































import { Vue, Component } from "vue-property-decorator";
import CustomButton from '@/components/Globals/CustomButton.vue';
import CustomContainer from './Globals/CustomContainer.vue';
import CustomText from '@/components/Globals/CustomText.vue';
import CustomModal from '@/components/Modals/wrapper/modalWrapper.vue';
import ModalHeader from '@/components/molecule.modal.header.vue';
import SizeSelectionContent from '@/components/molecule.ugcSizeSelection.content.vue';
import sizeSelect from '@/mixins/UGC/sizeSelect';

@Component({
  components: {
    CustomButton,
    CustomContainer,
    CustomText,
    CustomModal,
    ModalHeader,
    SizeSelectionContent
  },
  mixins: [
    sizeSelect
  ]
})
export default class UgcSizeSelection extends Vue {
  disabledCta = true as boolean;

  blockCtaPrimaryButton(block: boolean): void {
    this.disabledCta = block;
  }
}
